import { i18nKeys, literals } from './i18nkeys';

const translation: literals = {
  [i18nKeys.Pano]: 'Панорама',
  [i18nKeys.Scan]: 'Скан',
  [i18nKeys.FlightScheduledDateTitle]: 'Запланированная дата полета',
  [i18nKeys.FlightExifDateTitle]: 'Дата из EXIF',

  [i18nKeys.UploadsListActivity]: (daysBack: string) => `Ваша активность за ${daysBack} дней`,
  [i18nKeys.UploadsListActivityError]: 'Не удалось загрузить список загрузок',
  [i18nKeys.UploadsListActivityErrorDetails]: 'Пожалуйста, свяжитесь с командой поддержки',
  [i18nKeys.UploadsListNoUploads]: 'Загрузок не было',

  [i18nKeys.FlightDateConfirmationDatePickerDatePlaceholder]: 'Выберите дату полета',
  [i18nKeys.FlightDateConfirmationDatePickerExistingScheduleErrorMessage]:
    'Вы не можете загружать фотографии для другого расписания',

  [i18nKeys.InvoicingSubmitInvoice]: 'Отправить счет',
  [i18nKeys.InvoicingDescription]: 'Добавьте счет, включающий полеты за 2 последние недели.',
  [i18nKeys.InvoicingSelectDateButtonDescription]: 'Другие даты',
  [i18nKeys.InvoicingScanCostsPlaceholder]: 'Стоимость сканов',
  [i18nKeys.InvoicingScanCostsTitle]: 'Стоимость сканов',
  [i18nKeys.InvoicingPanoCostsPlaceholder]: 'Стоимость панорам',
  [i18nKeys.InvoicingPanoCostsTitle]: 'Стоимость панорам',
  [i18nKeys.InvoicingOtherCostsPlaceholder]: 'Прочие расходы',
  [i18nKeys.InvoicingOtherCostsTitle]: 'Прочие расходы',
  [i18nKeys.InvoicingTotalCostsTitle]: 'Итого',
  [i18nKeys.InvoicingPaymentLinkPlaceholder]: 'Ссылка на оплату',
  [i18nKeys.InvoicingPaymentLinkTitle]: 'Ссылка на оплату',
  [i18nKeys.InvoicingPaymentLinkErrorMessage]: 'Пожалуйста, добавьте корректную ссылку или оставьте поле пустым',
  [i18nKeys.InvoicingSubmitButtonTitle]: 'Отправить',
  [i18nKeys.InvoicingSubmitAnywayButtonTitle]: 'Все равно отправить',
  [i18nKeys.InvoicingSentButtonTitle]: 'Инвойс отправлен',
  [i18nKeys.InvoicingSendAnotherTitle]: 'Отправить новый инвойс',
  [i18nKeys.InvoicingPdfFileInputTitle]: 'Счет в формате PDF',
  [i18nKeys.InvoicingPdfFileButtonTitle]: 'Приложить PDF счет',
  [i18nKeys.InvoicingPdfFileButtonPendingTitle]: 'Загружается...',
  [i18nKeys.InvoicingUploadErrorHeader]: 'Что-то пошло не так. Инвойс не отправлен. Повторите попытку позже.',
  [i18nKeys.InvoicingNoCostsErrorDescription]: 'Заполните стоимость полетов',
  [i18nKeys.InvoicingNoLinkErrorHeader]: 'Пожалуйста, добавьте счет в формате pdf',
  [i18nKeys.InvoicingDatePickerStartDatePlaceholder]: 'Начало периода',
  [i18nKeys.InvoicingDatePickerEndDatePlaceholder]: 'Конец периода',
  [i18nKeys.InvoicingStartDateErrorDescription]: 'Выберите дату первого полета',
  [i18nKeys.InvoicingEndDateErrorDescription]: 'Выберите дату последнего полета',
  [i18nKeys.InvoicingExpectedCostsFetchErrorHeader]: 'Невозможно проверить соответствие стоимости сканов и панорам.',
  [i18nKeys.InvoicingCostsNotMatchErrorHeader]:
    'Стоимость сканов и панорам не совпадает со стоимостью оплачиваемых загрузок',
  [i18nKeys.InvoicingBillableUploadsTitle]: 'Оплачиваемые загрузки',
  [i18nKeys.InvoicingBillableUploadsTotalAmount]: 'Итого',
  [i18nKeys.InvoicingBillableUploadsListFirstColTitle]: 'Дата, Площадка',
  [i18nKeys.InvoicingBillableUploadsListSecondColTitle]: 'Стоимость',
  [i18nKeys.InvoicingBillableUploadsSelectDatesErrorMessage]: 'Пожалуйста выберите дату начла и конца периода',
  [i18nKeys.InvoicingBillableUploadsNoUploadErrorMessage]:
    'Не найдено ни одной оплачиваемой загрузки за выбранный период',
  [i18nKeys.InvoicingBillableUploadsLoaderTitle]: 'Загружаем оплачиваемые загрузки',
  [i18nKeys.InvoicingBillableUploadsProcessingInfoMessage]:
    'Пожалуйста, подождите 48 часов перед тем как отправлять счет за загрузки в стадии обработки',
  [i18nKeys.InvoicingBillableUploadsProcessingStatus]: 'В обработке',
  [i18nKeys.InvoicingBillableUploadsFetchErrorMessage]:
    'Возникли проблемы с получением данных о загрузках. Попробуйте еще раз.',
};

export default translation;
